<template>
  <div class="storage">
    <div class="heard">
      <router-link to="/xingHanDaPing">
        <div class="img">
          <img src="../../../../assets/dapingImg/logo.png" alt />
        </div>
      </router-link>
      <span class="title">物流业务</span>
      <div class="date">
        <span>{{ nowDate + ' ' + nowWeek }}</span>
      </div>
    </div>

    <div class="storagemain">
      <el-row :gutter="24">
        <!-- 左侧 -->
        <el-col :span="8">
          <div class="grid-content bg-purple">
            <div class="left">
              <div class="left_h">
                <span class="span_one">订单数据</span>
              </div>
              <!-- <div class="left_heard">出入库数据</div> -->
              <div class="left_table">
                <div id="table">
                  <vue-seamless-scroll :data="orderData" class="seamless-warp">
                    <ul class="item">
                      <li class="dingdan" v-for="item in orderData"  :key="item.id">
                        <div class="itemA">
                          <div><p :title="item.orderNo">订单编号：{{item.orderNo}}</p></div>
                          <div><p>订单状态：{{item.status==1201||item.status==1004?'待承运':item.status==1202?'承运中':'已送达'}}</p></div>
                        </div>
                        <div class="itemB">
                          <p style="color:#fe4830">{{item.deliverAddress}}</p>
                          <i class="fa fa-long-arrow-right" aria-hidden="true" style="color:#03faec;"></i>
                          <p style="color:#fbad00">{{item.receivingAddress}}</p>
                        </div>
                         <div class="itemA">
                          <div>
                            <p>货物信息：{{item.productTypeName}}/{{item.weight}}{{item.unitMeasurement}}</p>
                            <p>运输时间：{{item.transportStartOperateDate|dateFormat}}</p>
                          </div>
                          <div>
                            <p>发单人：{{item.sendUserName}}</p>
                            <p>送达时间：{{item.transportEndOperateDate|dateFormat}}</p>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 中间 -->
        <el-col :span="9">
          <div class="grid-content bg-purple center">
            <div class="left_one">
              <div class="block">
                 <div class="left_h">
                    <span class="span_one">物流数据</span>
                  </div>
                  <div class="wuliushuju">
                    <div class="itemA">
                      <div class="top">
                          <span class="shuju" style="color:#14D5FF;">{{OrderTotalData.dailyOrders}}</span>
                          <span class="name">当日订单量(个)</span>
                      </div>
                      <div class="bottom">
                          <span class="shuju">{{OrderTotalData.orderTotal?OrderTotalData.orderTotal:'0'}}</span>
                          <span class="name">累计订单量(个)</span>
                      </div>
                    </div>
                    <div class="itemA">
                      <div class="top">
                          <span class="shuju" style="color:#FE4830;">{{OrderTotalData.dailyWeight?OrderTotalData.dailyWeight:'0'}}</span>
                          <span class="name">当日发货量(吨)</span>
                      </div>
                      <div class="bottom" style="background-color:#FE4830;">
                          <span class="shuju">{{OrderTotalData.weightTotal < 10000 ? OrderTotalData.weightTotal:(OrderTotalData.weightTotal?OrderTotalData.weightTotal/10000:0)}}</span>
                          <span class="name">累计发货量({{OrderTotalData.weightTotal< 10000?'吨':'万吨'}})</span>
                      </div>
                    </div>
                    <div class="itemA">
                      <div class="top">
                          <span class="shuju" style="color:#FBAD00;">{{OrderTotalData.dailyFreight?OrderTotalData.dailyFreight:'0'}}</span>
                          <span class="name">当日支出运费(元)</span>
                      </div>
                      <div class="bottom" style="background-color:#FBAD00;">
                          <span class="shuju">{{OrderTotalData.freightTotal< 10000 ? OrderTotalData.freightTotal:(OrderTotalData.freightTotal?OrderTotalData.freightTotal/10000:0)}}</span>
                          <span class="name">累计支出运费({{OrderTotalData.freightTotal< 10000 ?'元':'万元'}})</span>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
            <div class="left_two">
              <div class="map">
                <div class="left_h">
                  <span class="span_one">发货数据统计</span>
                  <span class="span_two">单位(吨)</span>
                </div>
                <div>
                  <!--为echarts准备一个具备大小的容器dom-->
                  <div id="myChart" class="idChart"></div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <!-- 右侧 -->
        <el-col :span="7">
          <div class="grid-content bg-purple">
            <div class="left">
              <div class="left_h">
                <span class="span_one">运单数据</span>
              </div>
              <div class="left_table">
                <div id="table">
                  <vue-seamless-scroll :data="wayData" class="seamless-warp">
                    <ul class="item">
                      <li class="yundan" v-for="item in wayData" :key="item.id">
                        <div>
                          <p :title="item.wayNo">运单编号：{{item.wayNo}}</p>
                          <p>承运司机：{{item.dirverName}}</p>
                          <p>承运车辆：{{item.vhcNo}}</p>
                          <p :title="item.currentaddr">最新位置：{{item.currentaddr?item.currentaddr:'-'}}</p>
                        </div>
                        <div>
                          <p>运单状态：{{item.status==2002 ?'已接单':item.status==2003 ?'运输中':'待签收'}}</p>
                          <p>接单时间：{{item.receivingTime|dateFormat}}</p>
                          <p>装车时间：{{item.outTime|dateFormat}}</p>
                          <p>卸车时间：{{item.arrivalTime|dateFormat}}</p>
                        </div>
                      </li>
                    </ul>
                  </vue-seamless-scroll>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import {
  socOrderrecordList,
  socWayrecordList,
  socOrderTotal,
  orderWave
} from '@/api/data-center-server'
export default {
  data () {
    return {
      intChange1: null,
      nowDate: '', // 当前日期
      nowTime: '', // 当前时间
      nowWeek: '', // 当前星期
      charts: '',
      seerr: '',
      mapTimer: '',
      timer: '',
      OrderTotalData: {}, // 物流数据
      orderData: [], // 订单数据
      wayData: [] // 运单统计

    }
  },
  created () {},
  mounted () {
    this.socOrderTotalFn()// 物流数据
    this.churkuDataS() // 订单数据
    this.kehuDataS() // 运单数据
    this.fahuoDataS() // 出入库波动
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    } else {
      this.timer = setInterval(() => {
        this.socOrderTotalFn()// 物流数据
        this.churkuDataS() // 订单数据
        this.kehuDataS() // 运单数据
      }, 1000 * 60 * 2)
    }
  },
  updated () {},
  // 销毁定时器
  beforeDestroy: function () {
    if (this.getDate) {
      // console.log("销毁定时器");
      clearInterval(this.getDate) // 在Vue实例销毁前，清除时间定时器
    }
  },
  methods: {
    fahuoDataS () {
      orderWave({})
        .then(res => {
          this.fahuoData = []
          this.zhuangcheData = []
          this.shengyuData = []
          this.nameData = []
          res.forEach((item, index) => {
            this.nameData.push(dateFormat(item.statisticalDate))
            this.fahuoData.push(item.deliverWeight)
            this.zhuangcheData.push(item.loadingWeight)
            this.shengyuData.push(item.surplusWeight)
          })
          let myChart = this.$echarts.init(document.getElementById('myChart'))

          // 柱状图数据
          var map4Data1 = this.fahuoData
          var map4Data2 = this.zhuangcheData
          var map4Data3 = this.shengyuData
          // 绘制图表--柱状
          myChart.setOption({
            color: ['#0DD9FE', '#52F23A', '#FFAF03'],
            // backgroundColor: "#323a5e",
            grid: {
              left: '2%',
              right: '4%',
              bottom: '9%',
              top: '25%',
              containLabel: true
            },
            legend: {
              icon: 'circle',
              data: ['发货量', '装车量', '卸车量'],
              textStyle: {
                color: '#fff'
              }
            },
            // ---  提示框 ----
            tooltip: {
              show: true, // 是否显示提示框，默认为true
              axisPointer: {
                // 指示样式
                type: 'shadow'
              },
              formatter: function (value) {
                return value.marker + value.seriesName + '：' + value.value
              },
              padding: 5,
              textStyle: {
                // 提示框内容的样式
                color: '#fff'
              }
            },
            calculable: true,
            xAxis: {
              type: 'category',
              data: this.nameData,
              axisLine: {
                lineStyle: {
                  color: 'white'
                }
              },
              axisLabel: {
                // interval: 0,
                // rotate: 40,
                textStyle: {
                  fontFamily: 'Microsoft YaHei'
                }
              }
            },
            yAxis: {
              type: 'value',
              data: ['2000', '4000', '6000', '8000'],
              axisLine: {
                show: false,
                lineStyle: {
                  color: 'white'
                }
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: 'rgba(255,255,255,0.3)'
                }
              },
              axisLabel: {}
            },
            series: [
              {
                name: '发货量',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data1
              },
              {
                name: '装车量',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data2
              },
              {
                name: '卸车量',
                type: 'bar',
                barGap: 0,
                barWidth: '15%',
                data: map4Data3
              }
            ]
          })
        })
        .catch(err => {
          console.log(err)
        })
      function dateFormat (data) {
        var t = new Date(data) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var str = ''
        if (data == null || data == '') {
          str = '--'
        } else {
          str =
          month +
          '.' +
          date
        }
        return str
      }
    },
    // 物流数据
    socOrderTotalFn () {
      socOrderTotal().then(res => {
        this.OrderTotalData = res
      }).catch(err => {
        console.log(err)
      })
    },
    // 订单数据
    churkuDataS () {
      socOrderrecordList().then(res => {
        this.orderData = res
      }).catch(err => {
        console.log(err)
      })
    },
    // 运单统计
    kehuDataS () {
      socWayrecordList().then(res => {
        this.wayData = res
      }).catch(err => {
        console.log(err)
      })
    }

  },

  computed: {
    optionSingleHeightTime () {
      return {
        // singleHeight: 26,
        // waitTime: 2500,
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: this.kehuTableData.length, // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true, // 是否开启鼠标悬停stop
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1200 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  destroyed () {
    clearInterval(this.timer, this.mapTimer)
  }
}
</script>

<style lang="less" scoped>
.wuliushuju{
  height: 40vh;
  color: #fff;
  display: flex;
  .itemA{
    width: 33%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  .shuju{
    font-size: 46px;
    margin-bottom: 10px;
  }
  .name{
    font-size: 12px;
  }
  .bottom,.top{
    display: flex;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  }
  .bottom{
    .shuju{
      font-size: 32px;
    }
    width: 170px;
    height: 170px;
    border-radius: 50%;
    background-color: #14D5FF;
  }
}
.heard {
  width: 100%;
  height: 6vh;
  line-height: 6vh;
  display: flex;
  background: url("../../../../assets/dapingImg/标题光条.png") no-repeat;
  background-size: 100% 100%;
  text-align: center;
  .title {
    flex: 1;
    font-size: 30px;
    font-weight: 700;
    color: #03faec;
  }
  .date {
    font-size: 16px;
    color: #ffdd17;
  }
   .img{
    height: 6vh;
    img{
      height: 100%;
    }
  }
}
.seamless-warp {
  overflow: hidden;
  ul {
   margin: 0;
   padding: 0;
// margin-top: 10px;
   color: #03faec;
   li{
      background:rgba(3, 250, 236, 0.2);
      padding:10px;
      font-size: 12px;
      margin-bottom: 10px;
   }
  }
  .yundan{
    display: flex;
    div{
      width: 50%;
      p{
         white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        margin-bottom: 10px;
      }
    }
  }
  .dingdan{
    .itemA{
      display: flex;
      div{
        width: 50%;
        p{
           margin: 0;
          margin-bottom: 10px;
        }
      }
    }
    .itemB{
      font-size: 16px;
      display: flex;
      align-items: center;
       margin-bottom: 10px;
      p{
         white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          word-break: break-all;
        margin: 0;
      }
      .fa-long-arrow-right{
        margin: 0 10px;
      }
    }
  }
}
.left_h {
  height: 30px;
  line-height: 30px;
  color: #03faec;
  // font-weight: 700;
  font-size: 20px;
  background: url("../../../../assets/dapingImg/mk-title-bg.png") no-repeat;
  background-size: 100% 100%;
  .span_one {
    float: left;
    margin-left: 10px;
    font-size: 16px;
  }
  .span_two {
    float: right;
    margin: 5px;
    font-size: 16px;

    font-weight: normal;
  }
}

.map_heard {
  color: #03faec;
  font-weight: 700;
  font-size: 35px;
  position: absolute;
  left: 46%;
  top: 30px;
}
.storagemain {
  width: 100%;
  height: 100%;
  position: relative;
}

.storage {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  // padding: 0 29px;
  background: url("../../../../assets/dapingImg/bg.png") 100%;
}
.left {
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 90vh;
  width: 100%;
  background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
  // overflow-x: scroll;
}
.left_two {
  //折线图
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 44vh;
  overflow: hidden;
  width: 100%;
  background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;
  // overflow-x: scroll;
}
.left_one {
  //轮播
  // background-color: #ccc;
  padding: 0px 0px 0px 1px;
  box-sizing: border-box;
  height: 45vh;
  margin-bottom: 10px;
  width: 100%;
  background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
  background-size: 100% 100%;

  // overflow-x: scroll;
}

.right_hour {
  color: red;
  height: 60px;
  line-height: 60px;
  text-align: center;
}
.center_heard {
  font-size: 30px;
  font-weight: 700;
  text-align: center;
  height: 60px;
  line-height: 60px;
}

.left_main {
  height: 300px;
  text-align: center;
  .number {
    height: 6vh;
    line-height: 6vh;
    color: #fff;
    font-size: 18px;
    b {
      font-size: 25px;
      margin-left: 10px;
    }
  }
  .stock {
    height: 4vh;
    width: 100%;
    // background-color: pink;
    // position: absolute;
    // top: 15vh;
    // bottom: 0;
    // bottom: 3vh;
    // left: 0;
    font-size: 16px;
    ul {
      height: 8vh;
      overflow: hidden;
      // background: url("../../../../assets/dapingImg/bg1.png") no-repeat;
      // background-size: 100% 100%;
      display: flex;
      margin: 0;
      padding: 0;
      li {
        flex: 1;
        text-align: center;
        margin: 0;
        padding: 0;
        // margin-left: 55px;
      }
      // 日入
      .b_r {
        font-size: 20px;
        color: #eed808;
      }
      // 日出
      .b_c {
        font-size: 20px;
        color: #4aec45;
      }
      p {
        margin: 0;
      }
      span {
        color: #fff;
      }
    }
  }
  .hot {
    width: 100%;
    // height: 100%;
  }
  ul {
    display: flex;
    margin-top: 25px;
  }
  li {
    flex: 1;
    // background-color: #fff;
    list-style: none;
    // height: 80px;
    width: 25%;
    margin-left: 5px;
    margin-right: 5px;
    text-align: center;
    padding-top: 10px;
    box-sizing: border-box;
    span {
      font-weight: 700;
    }
  }
}
.left_heard {
  color: #fff;
  font-weight: 700;
  //   text-align: center;
  //   margin-left: 20px;
  line-height: 60px;
  width: 100%;
  height: 60px;
  // background-color: #1a85e1;
}
.left_table {
  width: 100%;
  height: 85vh;
  overflow: hidden;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.pieChart {
  width: 100%;
  height: 25vh !important;
}
.idChart {
  width: 100%;
  height: 40vh;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  // background-color: #f9fafc;
}
</style>
